import supabaseClient from '@/api/supabaseClient.ts';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { FunctionsHttpError } from '@supabase/supabase-js';
import { BackendErrorResponse } from '@/types/response/BackendErrorResponse';

const useAdminDeleteUser = () => {
  const queryClient = useQueryClient();

  const mutationFn = async (user_id: string) => {
    const { data, error } = await supabaseClient.functions.invoke('admin_delete_user', {
      body: { user_id },
    });

    if (error) {
      if (error instanceof FunctionsHttpError) {
        const err: BackendErrorResponse = await error.context.json();
        throw new Error(err.errors.join(', '));
      }
      throw new Error((error as Error).message);
    }

    return data;
  };

  return useMutation({
    mutationFn,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin-carers'] });
      queryClient.invalidateQueries({ queryKey: ['admin-families'] });
    },
  });
};

export default useAdminDeleteUser;
